import template from './llm-assignment-list.html.twig';
import '../../component/llm-assignment-form';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('topdata-llm-connect-llm-assignment-list', {
    template,

    inject: ['repositoryFactory'],

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
    ],

    data() {
        return {
            items: null,
            isLoading: true,
            sortBy: 'purpose',
            sortDirection: 'ASC',
            limit: 25,
            activeModal: false,
            isFormInitialized: false,
            currentEntity: null,
            itemToDelete: null,
            showDeleteModal: false,
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('tdlc_llm_assignment');
        },

        deleteConfirmText() {
            if (!this.itemToDelete) return '';
            return this.$t('TopdataLlmConnectSW6.assignment.deleteConfirmText', { purpose: this.itemToDelete.purpose });
        },

        columns() {
            return [{
                property: 'purpose',
                label: this.$tc('TopdataLlmConnectSW6.assignment.columnPurpose'),
                allowResize: true,
                primary: true,
                sortable: true,
            }, {
                property: 'owner',
                label: this.$tc('TopdataLlmConnectSW6.assignment.columnOwner'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'description',
                label: this.$tc('TopdataLlmConnectSW6.assignment.columnDescription'),
                allowResize: true,
                sortable: true,
            }, {
                property: 'chain',
                label: this.$tc('TopdataLlmConnectSW6.assignment.columnChain'),
                allowResize: true,
            }, {
                property: 'active',
                label: this.$tc('TopdataLlmConnectSW6.assignment.columnActive'),
                allowResize: true,
                sortable: true,
            }];
        },
    },

    mounted() {
        this.getList();
    },

    methods: {
        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria.addSorting(Criteria.sort(this.sortBy, this.sortDirection));

            this.repository.search(criteria).then((result) => {
                this.total = result.total;
                this.items = result;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onPageChange(params) {
            this.page = params.page;
            this.limit = params.limit;
            this.getList();
        },

        onSortColumn(column) {
            this.sortBy = column.dataIndex ?? column.property;
            this.sortDirection = column.sortDirection ?? 'ASC';
            this.getList();
        },

        onAddAssignment() {
            this.currentEntity = this.repository.create();
            this.currentEntity.purpose = '';
            this.currentEntity.owner = null;
            this.currentEntity.description = null;
            this.currentEntity.chain = '';
            this.currentEntity.active = true;
            this.isFormInitialized = true;
            this.activeModal = true;
        },

        onEditAssignment(item) {
            this.repository.get(item.id).then((entity) => {
                this.currentEntity = entity;
                this.isFormInitialized = true;
                this.activeModal = true;
            });
        },

        onCloseModal() {
            this.activeModal = false;
            this.isFormInitialized = false;
            this.getList();
        },

        onShowDeleteModal(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },

        onCloseDeleteModal() {
            this.showDeleteModal = false;
            this.itemToDelete = null;
        },

        onConfirmDelete() {
            this.repository.delete(this.itemToDelete.id).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataLlmConnectSW6.assignment.deleteSuccess'),
                });
                this.onCloseDeleteModal();
                this.getList();
            }).catch(() => {
                this.onCloseDeleteModal();
            });
        },
    },
});